var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9976 16.8843H20.8996V12.6849H18.5586V14.7647H16.4682V16.8733H18.5418V19.4486H14.3343V14.7877H9.89287V19.4419H5.68485V16.8829H7.76131V14.7781H5.67527V12.6787H3.34051V16.8642H1V10.3185H3.31079V7.98327H5.66424V6.10377H7.76801V4.00192H9.87227V6.08173H14.3199V4H16.4467V6.08844H18.5481V7.96698H20.8833V10.3056H23L22.9976 16.8843ZM10.0956 11.4691V9.15975H7.78911V11.471L10.0956 11.4691ZM14.3535 11.4605H16.658V9.16503H14.3535V11.4605Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarM);
export default __webpack_public_path__ + "static/media/avatar-m.f9e596fbeaacda5c7595f48eafe73db5.svg";
export { ForwardRef as ReactComponent };